app-icon {
	display: flex;

	& > svg {
		fill: currentColor;
		inline-size: 1em;
	}

	// 320/512
	&:is(
		[icon='forward-step'],
		[icon='backward-step'],
		[icon='chevron-left'],
		[icon='chevron-right'],
		[icon='pause'],
		[icon='facebook-f'],
		[icon='caret-down'],
		[icon='caret-up']
	) > svg {
		aspect-ratio: 5/8;
	}

	// 352/512
	&:is(
		[icon='forward-step'],
		[icon='backward-step'],
		[icon='chevron-left'],
		[icon='chevron-right'],
		[icon='pause'],
		[icon='facebook-f'],
		[icon='lightbulb']
	) > svg {
		aspect-ratio: 5/8;
	}

	// 384/512
	&:is(
		[icon='xmark'],
		[icon='hiking'],
		[icon='tree'],
		[icon='pinterest-p'],
		[icon='play']
	) > svg {
		aspect-ratio: 3/4;
	}

	// 192/512
	&:is(
		[icon='caret-left'],
		[icon='caret-right']
	) > svg {
		aspect-ratio: 3/8;
	}

	// 448/512
	&:is(
		[icon="arrow-right"],
		[icon='bars'],
		[icon='menu'],
		[icon='check'],
		[icon='chevron-down'],
		[icon='chevron-up'],
		[icon='lock'],
		[icon='user'],
		[icon='instagram'],
		[icon='linkedin'],
		[icon='linkedin-in'],
		[icon='square-facebook'],
		[icon='square-instagram'],
		[icon='calendar'],
		[icon='atlas'],
		[icon='train'],
		[icon='snowflake'],
		[icon='calendar-day'],
		[icon='square-x-twitter']
		[icon="angle-up"]
	) > svg {
		aspect-ratio: 7/8;
	}

	// 512/512
	&:is(
		[icon='arrow-circle-down'],
		[icon='arrow-circle-left'],
		[icon='arrow-circle-right'],
		[icon='arrow-circle-up'],
		[icon='circle-minus'],
		[icon='circle-play'],
		[icon='play-circle'],
		[icon='circle-plus'],
		[icon='comment'],
		[icon='download'],
		[icon='envelope'],
		[icon='envelope-solid'],
		[icon='phone'],
		[icon='phone-solid'],
		[icon='maginifying-glass'],
		[icon='search'],
		[icon='close'],
		[icon='times'],
		[icon='close-thin'],
		[icon='triangle-exclamation'],
		[icon='upload'],
		[icon='facebook'],
		[icon='helmet'],
		[icon='rowing'],
		[icon='hamburger'],
		[icon='gondola'],
		[icon='kayaking'],
		[icon='ziplining'],
		[icon='magnifying-glass'],
		[icon='helmet'],
		[icon='plus'],
		[icon='minus'],
		[icon='clock'],
		[icon='search-location'],
		[icon='search-dollar'],
		[icon='x-twitter'], 
		[icon='portal'],
		[icon='list']
	) > svg {
		aspect-ratio: 1;
	}

	// 576/512
	&:is(
		[icon='house'],
		[icon='fish'],
		[icon='youtube'],
		[icon='home'],
		[icon='map']
	) > svg {
		aspect-ratio: 9/8;
	}

	// 616/512
	&:is(
		[icon='store']
	) > svg {
		aspect-ratio: 77/64;
	}

	// 640/512
	&:is(
		[icon='link'],
		[icon='tractor'],
		[icon='biking'],
		[icon='ship'],
		[icon='campground'],
		[icon='caravan'],
		[icon='user-check'],
		[icon='code']
	) > svg {
		aspect-ratio: 5/4;
	}

	// 46/76
	&:is(
		[icon='big-chevron-left'],
		[icon='big-chevron-right']
	) > svg {
		aspect-ratio: 46/76;
	}

	// 14/11
	&:is(
		[icon='home-work']
	) > svg {
		aspect-ratio: 14/11;
	}

	// 12/13
	&:is(
		[icon='category'],
		[icon='signpost'],
		[icon='event-check']
	) > svg {
		aspect-ratio: 12/13;
	}

	// 11/13
	&:is(
		[icon='month'],
		[icon='flag']
	) > svg {
		aspect-ratio: 11/13;
	}

	&[icon='open-quote'] > svg {
		aspect-ratio: 63/50;
	}

	&[icon='speech-bubble-tail'] > svg {
		aspect-ratio: 147/50;
	}
}
